import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    height: 72,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-around",
    zIndex: theme.zIndex.appBar,
    width: "100vw",
  },
  footerBackdrop: {
    "-webkit-clip-path": "url(#clip-footer-path)",
    clipPath: "url(#clip-footer-path)",
    backdropFilter: "blur(18px)",
    width: "100%",
    height: 72,
    position: "absolute",
  },
  item: {
    background: "unset",
    border: "unset",
    zIndex: 1,
    width: "20%",
    position: "relative",
  },
  icon: {
    color: theme.colors.TextDefault,
  },
  iconActive: {
    color: theme.colors.Primary,
  },
  iconContainer: {
    color: theme.colors.TextDefault,
    background: "rgba(255, 255, 255, 0.10)",
    backdropFilter: "blur(18px)",
    zIndex: theme.zIndex.normal,
    padding: theme.spacing.space8,
    position: "absolute",
    borderRadius: "50%",
    left: "50%",
    transform: "translate(-50%, 0)",
    top: -theme.spacing.space16,
    height: 24,
  },
  svg: {
    position: "absolute",
    left: 0,
  },
  notifyWrapper: {
    position: "relative",
  },
  notifyBadge: {
    position: "absolute",
    top: 0,
    insetInlineEnd: 0,
    width: 6,
    height: 6,
    background: theme.colors.NotificationError,
    borderRadius: "50%",
  },
}));
